module.exports = __webpack_public_path__ + "static/media/overflow.bd4dd80d.svg";